<template>
  <div class="flex justify-center font-zona bg-gray-50 min-h-[60vh] py-10">
    <main class="flex flex-col items-center w-full max-w-5xl px-4">
      <h1
        class="uppercase font-semibold text-blue-500 text-2xl text-center mb-10"
      >
        Хариуцлагатай Уул Уурхай - Өөрийн үнэлгээ
      </h1>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
        <router-link
          to="/mm/member-assessment"
          class="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border border-gray-200 hover:border-green-400 hover:bg-green-50"
        >
          <div class="flex flex-col items-center text-center gap-4">
            <font-awesome-icon
              icon="fa-regular fa-building"
              class="text-5xl text-gray-300 group-hover:text-green-500 transition-all"
            />
            <span
              class="text-lg font-semibold uppercase text-gray-500 group-hover:text-green-600"
            >
              Гишүүн байгууллага
            </span>
          </div>
        </router-link>

        <router-link
          to="/mm/self-assessment"
          class="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border border-gray-200 hover:border-green-400 hover:bg-green-50"
        >
          <div class="flex flex-col items-center text-center gap-4">
            <font-awesome-icon
              icon="fa-regular fa-user"
              class="text-5xl text-gray-300 group-hover:text-green-500 transition-all"
            />
            <span
              class="text-lg font-semibold uppercase text-gray-500 group-hover:text-green-600"
            >
              Өөрийн сонирхлоор
            </span>
          </div>
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "MMAssessment",
};
</script>
